export const Identifiers = {
  isAppliance: ({ productType }) => {
    return !!(productType?.toUpperCase() === 'MAJOR_APPLIANCE');
  }
};